import { ctxIsApp } from "lib/app";
import { captureException } from "lib/sentry";

const redirect = () => {
  const referer = document.referrer || "A page";
  const error = new Error(
    `${referer} navigated to a new url instead of using the router`
  );
  console.error(error);
  captureException(error);
  window.location.href = "/app/launch";
};

/**
 * The /app/launch page controls logic like the route cache. Loading the site from a
 * different page will skip those steps. In case this happens, a quick fix is to navigate
 * to the launch page and start over.

 * For example, the only place that checks your biometrics and preloads the site is /app/launch,
 * so this check ensures none of our pages redirect with window.location directly, which would
 * bypass the biometric check.
 */
export const appInitialRouteCheck = () => {
  if (!process.browser) {
    return;
  }
  const isAppLaunchPage = window.location.pathname === "/app/launch";
  if (ctxIsApp() && !isAppLaunchPage) {
    redirect();
  }
};
